module.exports = __webpack_public_path__ + "img/icon_01.d66c0d0d.png";